import Factory from './Factory';
import { ConfigurationHelper } from './helpers';
import { Vue } from 'vue-property-decorator';

export default class Startup {
  static configureApp(): Promise<Factory> {
    return new Promise<Factory>((resolve, reject) => {
      ConfigurationHelper.loadConfiguration().then((config) => {
        if (config === null) { return reject('Config is null.'); }
        // set factory
        Vue.prototype.$appConfig = config;
        return resolve(new Factory(config));
      });
    });
  }
}
